document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".flex-layout.accordeon_contact-layout").forEach((layout) => {
        const items = [...layout.querySelectorAll(".item")];
        if (!items.length) return;

        const setOpen = (item, open) => {
            item.classList.toggle("is-open", open);
            item.querySelector(".item-toggle")?.setAttribute("aria-expanded", String(open));

            const panel = item.querySelector(".item-panel");
            if (panel) panel.inert = !open;
        };

        items.forEach((item) => {
            setOpen(item, false);

            item.querySelector(".item-toggle")?.addEventListener("click", () => {
                const isOpen = item.classList.contains("is-open");
                items.forEach((other) => setOpen(other, false));
                if (!isOpen) setOpen(item, true);
            });
        });
    });
});
